import styled, { css } from "styled-components";
import { FC } from "react";
import { components } from "react-select";

import { SelectComponentProps } from "./types";
import { styleWrappedComponent } from "./styleWrappedComponent";

const StyledGroup = styled.div`
  ${styleWrappedComponent(css`
    padding-top: 0;
    padding-bottom: 0;
  `)};
`;
type GroupProps = SelectComponentProps["Group"];

export const Group: FC<GroupProps> = ({ children, ...props }) => (
  <StyledGroup>
    <components.Group {...props}>{children}</components.Group>
  </StyledGroup>
);
